import React from 'react'
import { FormattedMessage } from 'react-intl'
import { ModalTitle } from 'app/common/modals/title'
import { H1, H3 } from 'app/common/typography'
import { colors } from 'shared/assets/styles'
import styled from 'styled-components'
import { ButtonMedium } from 'app/assets/styles'
import { media } from 'app/assets/styles'
import { toSrcSet } from 'shared/utils'
import { Picture } from 'react-responsive-picture'
import kingdom_points_tutorial from 'shared/assets/images/kingdom-tutorial/new-kingdom-points-tutorial-1x.webp'
import kingdom_points_tutorial_2x from 'shared/assets/images/kingdom-tutorial/new-kingdom-points-tutorial-2x.webp'
import kingdom_points_tutorial_3x from 'shared/assets/images/kingdom-tutorial/new-kingdom-points-tutorial-3x.webp'

const { yellow } = colors

type Props = {
    handleClose: () => void
}

const PointsTutorialModal = (props: Props) => {
    const { handleClose } = props

    const images = [
        kingdom_points_tutorial,
        kingdom_points_tutorial_2x,
        kingdom_points_tutorial_3x
    ]

    return (
        <Container>
            <ModalTitle
                center
                handleClose={handleClose}
                titleNode={
                    <div>
                        <FormattedMessage id="kingdom.dashboard.title">
                            {(text: string) => <H1 center>{text}</H1>}
                        </FormattedMessage>
                        <FormattedMessage id="help.crown">
                            {(text: string) => (
                                <H3 center color={yellow}>
                                    {text}
                                </H3>
                            )}
                        </FormattedMessage>
                    </div>
                }
            />
            <Content>
                <StyledPicture
                    sources={[
                        {
                            srcSet: toSrcSet(images)
                        }
                    ]}
                />
                <StyledButtonMedium onClick={handleClose} background={yellow}>
                    <FormattedMessage id="kingdom.points.tuto.cta" />
                </StyledButtonMedium>
            </Content>
        </Container>
    )
}

const Container = styled.div`
    padding: 20px;
    ${media.medium`
        padding: 40px;
    `};
`

const Content = styled.div`
    display: flex;
    flex-direction: column;
`

const StyledButtonMedium = styled(ButtonMedium)`
    align-self: center;
    margin: 20px 0;
    border: none;
`

const StyledPicture = styled(Picture)`
    width: 100%;
    height: 100%;
    margin: 40px 0;
`

export { PointsTutorialModal }
